<template>
  <div id="shard-app">
    <shard-nav></shard-nav>
    <transition name="router">
      <router-view/>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase'
import ShardNav from '@/components/shard-nav'
import { EventBus } from './event-bus.js'

export default {
  name: 'ShardApp',
  components: {
    ShardNav
  },
  data () {
    return {
      user: null
    }
  },
  methods: {
    signOut () {
      firebase.auth().signOut().then(() => {
        this.$root.user = null
        this.$router.push('/')
        EventBus.$emit('logged-off')
      }).catch(err => console.log(error))
    }
  },
  beforeCreate () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user
        EventBus.$emit('logged-on')
      }
    })
  },
  mounted () {
    const self = this

    EventBus.$on('sign-out', function () {
      self.signOut()
    })
  }
}
</script>

<style lang="scss">
// Vendors
@import 'assets/css/normalize.css';
@import 'assets/css/reset.css';
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900');

::selection {
  color: white;
  background: #E91E63;
  text-shadow: none;
}

html {
  background: black;
}

body {
  hyphens: none;
  overflow: hidden;
}

html, body, #shard-app {
  height: 100%;
}

* {
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

#shard-app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}

.polygon-circle {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}

.router-enter-active, .router-leave-active {
  transition: opacity .5s;
}

.router-enter, .router-leave-to {
  opacity: 0;
}

.shard-button {
  border: none;
  background: transparent;
  color: white;
  padding: 10px 15px;
  margin-top: 18px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all .2s ease-in-out;
  font-size: .9em;
  outline: none;

  &:hover {
    opacity: .8;
  }
}
</style>



// WEBPACK FOOTER //
// src/ShardApp.vue